<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.cadastro.ramoAtividade"
        ref="RkmDataTable"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                v-if="authorize('cadastro-ramo-atividade-update')"
                :to="{name: 'cadastro-ramo-atividade-edit', params: {id: item.ramo_atividade_id}}"
                color="primary"
                small
                title="Editar"
                v-rkm-tooltip.hover
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                v-if="authorize('cadastro-ramo-atividade-destroy')"
                @click="handleDestroy(item)"
                color="danger"
                small
                title="Excluir"
                v-rkm-tooltip.hover
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import {authorization, error, notification} from '@/mixins'

export default {
    computed: {
        fields() {
            return [
                {key: 'ramo_atividade_nome', label: 'Nome', name: 'cadastro_ramo_atividade.nome', searchable: true, sortable: true},
                {class: 'col-min text-center', key: 'actions', label: 'Ações'},
            ]
        },
    },
    inject: ['repositories'],
    methods: {
        handleDestroy(item) {
            const destroy = () => this.repositories.cadastro.ramoAtividade.destroy(item.ramo_atividade_id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDangerConfirmation('Confirmação', `Deseja realmente excluir a ramo de atividade ${item.ramo_atividade_nome}?`, destroy, this.handleError)
        },
    },
    mixins: [authorization, error, notification],
}
</script>